import { InsuranceType } from '@/models/insurance.ts';

export type ChainStep = {
    order: number;
    appointment_type_id: string;
    is_main_practitioner: boolean;
};

export enum GapUnit {
    MINUTES = 'min',
    HOURS = 'hrs',
    DAYS = 'days',
}

export type ChainGap = {
    from_step: number;
    to_step: number;
    min_duration: string; // ISO 8601 duration, e.g. "P5D"
    max_duration?: string; // ISO 8601 duration, e.g. "P10D"
};

export type MergedGap = { min_duration: string; max_duration?: string };

export type CreateChainConfigDto = {
    name: { de: string; en: string };
    description?: { de: string };
    practice_id: string;
    insurance_types: InsuranceType[];
    is_for_new_patients: boolean;
    is_for_returning_patients: boolean;
    is_bookable_by_patient: boolean;
    steps: ChainStep[];
    gaps: ChainGap[];
};

export type AppointmentChainConfig = {
    id: string;
    instance_id: string;
    customer_id: string;
    name: { de: string; en: string };
    description?: { de: string };
    practice_id: string;
    insurance_types: InsuranceType[];
    is_for_new_patients: boolean;
    is_for_returning_patients: boolean;
    is_bookable_by_patient: boolean;
    steps: ChainStep[];
    gaps: ChainGap[];
    meta: {
        created_at: string;
        updated_at: string;
        deleted_at?: string;
    };
};

export type ChainSelection = {
    chain_id?: string;
    insurance_type?: InsuranceType;
    start_date: string;
    planning_mode?: ChainPlanningMode;
    removed_orders: number[];
    calendar_selections: Record<number, string>;
    main_practitioner_id?: string;
    is_chain_cleared_by_patient_type?: boolean;
};

export enum ChainBookingStep {
    CONFIGURE = 'configure',
    TUNE = 'tune',
    SUGGEST = 'suggest',
}

export enum ChainPlanningMode {
    AUTO = 'AUTO',
    MANUAL = 'MANUAL',
}
